<template>
  <div
    class="w-full min-h-[50px] max-h-[50px] flex items-center justify-between sticky top-0 z-999 border-gray-200 px-2"
    :class="classes"
  >
    <ChevronLeftIcon
      class="size-[30px] shrink-0 cursor-pointer text-gray-800"
      @click="handleClick"
    />
    <div
      v-if="webviewStore.showNavbar"
      class="font-secondary font-medium text-[16px] leading-[22px] text-gray-800"
    >
      <slot />
    </div>
    <div class="w-[30px]"></div>
  </div>
</template>

<script setup lang="ts">
import { NativeActionsEnum, useWebviewStore } from '@/shared/stores/webview'
import { ChevronLeftIcon } from '@dacr/icons'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const route = useRoute()
const router = useRouter()
const webviewStore = useWebviewStore()

const classes = computed(() => ({
  'bg-white border-b': webviewStore.showNavbar,
}))

const handleClick = () => {
  const previousRoute = route.path.toString()

  router.back()

  setTimeout(() => {
    if (route.path === previousRoute) {
      webviewStore.postMessage({
        type: NativeActionsEnum.NavigationBack,
      })
    }
  })
}
</script>
